import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { number, shape, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { withViewport } from '../../util/contextHelpers';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  AccountView,
} from '../../components';

import CookiesTab from './components/CookiesTab/CookiesTab';
import css from './AccountPrivacyPage.module.css';

const MOBILE_MAX_WIDTH = 767;

const AccountPrivacyPage = (props) => {
  const {
    currentTab,
    currentUser,
    scrollingDisabled,
    viewport,
    intl,
  } = props;
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const tabs = {
    'Cookies': {
      tabName: 'Cookies',
      routeName: 'AccountPrivacyPage',
      title: intl.formatMessage({ id: 'AccountPrivacyPage.cookiesTabTitle' }),
      component: <CookiesTab currentUser={ensuredCurrentUser} />,
      tipTitle: intl.formatMessage({ id: 'AccountPrivacyPage.cookiesTabTipTitle' }),
      tip: intl.formatMessage({ id: 'AccountPrivacyPage.cookiesTabTip' }),
    },
  };
  const pageTitle = intl.formatMessage({ id: 'AccountPrivacyPage.pageTitle' });
  const viewTitle = intl.formatMessage({ id: 'AccountPrivacyPage.viewTitle' });
  const isMobile = viewport.width <= MOBILE_MAX_WIDTH;
  
  return (
    <Page title={pageTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AccountPrivacyPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <AccountView
            title={viewTitle}
            tabs={tabs}
            currentTab={currentTab}
            intl={intl}
          />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          {!isMobile && (
            <Footer />
          )}
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  )
};

AccountPrivacyPage.defaultProps = {
};

AccountPrivacyPage.propTypes = {
  currentTab: string.isRequired,
  currentUser: propTypes.currentUser,
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

export default compose(
  connect(
    mapStateToProps
  ), withViewport, injectIntl
)(AccountPrivacyPage);
